import { getToken } from "../../setup/api";

export default {
  user: null,
  myCourses: {},
  logged: !!getToken()
};
